import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './AnimatedSlider.scss';
import { CarouselInjectedProps } from 'pure-react-carousel';

export type AnimatedSliderProps = {
  threshold?: number;
};

interface ViewModelInjectedProps extends CarouselInjectedProps {
  currentSlide?: number;
  totalSlides?: number;
  visibleSlides?: number;
}

class AnimatedSlider extends React.Component<
  ViewModelInjectedProps & AnimatedSliderProps
> {
  render() {
    const { currentSlide, threshold, totalSlides, visibleSlides } = this.props;
    if (!visibleSlides || !currentSlide || !totalSlides || !threshold)
      return null;

    const sliderWidth = (visibleSlides / totalSlides) * 100;
    const sliderPosition = currentSlide * ((1 / totalSlides) * 100);
    const sliderStyle = {
      left: `${sliderPosition}%`,
      width: `${sliderWidth}%`,
    };

    if (totalSlides < threshold) return null;

    return (
      <div className={cn(s.animatedSliderContainer)}>
        <div className={s.animatedSliderRailing}>
          <div className={s.animatedSliderIndicator} style={sliderStyle} />
        </div>
      </div>
    );
  }
}

export default AnimatedSlider;
